import { render, staticRenderFns } from "./SimilarPricedCars.vue?vue&type=template&id=a4bfe53a"
import script from "./SimilarPricedCars.vue?vue&type=script&lang=js"
export * from "./SimilarPricedCars.vue?vue&type=script&lang=js"
import style0 from "./SimilarPricedCars.vue?vue&type=style&index=0&id=a4bfe53a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports